import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import PageUrl from '../../../dispatcher/pageUrl';
import HostApp from '../../../api/host/hostApp';

const RedirectTo = (page) =>  {
    return PageUrl(page);
};

const IndexRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={ props => {
      return ( <Redirect to={ RedirectTo(rest.lic_state.currentPage) } /> ) ;
      }
    }
  />
);

const mapStateToProps = state => ({
    isAuthenticated: state.auth.isAuthenticated,
    lic_state: state.lic_state,
});

export default connect(
  mapStateToProps,
  null
)(IndexRoute);



// WEBPACK FOOTER //
// ./src/app/components/index-route/index.js